module.exports = __webpack_public_path__ + "img/ИФ-1(А)-003-m.e20b7ece.png";